import React from 'react';
import {View, Text, SafeAreaView, StyleSheet, ScrollView, TextInput, TouchableOpacity, KeyboardAvoidingView, TouchableWithoutFeedback, Keyboard, Platform, Image} from 'react-native';
import config from '../config';
import authService from '../services/auth';
import I18n from "../utils/i18n";
import AlertPopUpModal from '../components/AlertPopUpModal';
import AsyncStorage from '@react-native-async-storage/async-storage';
import commonStyles from './../styles/common';
import profileService from '../services/profile';
import LeftChevronIcon from './../assets/icons/left-chevron.svg';

class RegisterWithEmail extends React.Component {
  constructor(props) {
    super(props);

    this.redirectTo =  this.props?.route?.params?.redirectTo || this.props.redirectTo;
    this.barId = this.props?.route?.params?.barId || this.props.barId;
    this.tableNumber = this.props?.route?.params?.tableNumber || this.props.tableNumber;

    this.default_modal_props = {
      icon: '',
      title: '',
      text: '',
    }

    this.loading_modal_props = {
      ...this.default_modal_props,
      icon: 'loading',
      title: I18n.t('loading')
    }

    this.state = {
      email: '',
      otp: '',
      fullname: '',
      email_pristine: true,
      otp_pristine: true,
      fullname_pristine: true,
      otp_sent: false,
      otp_timer: 0,
      otp_tries: 0,
      loading: false,
      is_verified: false,
      isModalVisible: false,
      modal: {
        icon: '',
        title: '',
        text: '',
        okCallback: null
      }
    };
  }

  async sendOtp() {

    if (!this.validateEmail()) {
      return
    }

    this.setState({
      loading: true,
      isModalVisible: true,
      modal: {
        ...this.loading_modal_props
      }
    });

    let payload = {
      email: this.state.email
    }
    let registerRes = await authService.loginWithEmail(payload);
    if (registerRes.error) {
      this.setState({
        loading: true,
        isModalVisible: true,
        modal: {
          ...this.default_modal_props,
          icon: 'error',
          title: I18n.t('error'),
          text: I18n.t(registerRes.error_code),
          okCallback: () => {
            this.setState({
              loading: false,
              isModalVisible: false
            });
          }
        }
      });
      return
    }

    this.setState({
      otp_sent: true,
      otp_timer: 60,
      loading: false,
      isModalVisible: false
    });

    this.otpTimer = setInterval(() => {
      if (this.state.otp_timer > 0) {
        this.setState({
          otp_timer: this.state.otp_timer - 1
        });
      } else {
        clearInterval(this.otpTimer);
        this.setState({
          otp_timer: 0
        });
      }
    }, 1000);
  }

  async login() {
    if (!this.validateEmail() || !this.validateOtp()) {
      return
    }

    this.setState({
      loading: true,
      isModalVisible: true,
      modal: {
        ...this.loading_modal_props
      }
    });

    let payload = {
      email: this.state.email,
      otp: this.state.otp
    }

    let registerRes = await authService.verifyLoginWithEmail(payload);
    if (registerRes.error) {
      this.setState({
        loading: true,
        isModalVisible: true,
        modal: {
          ...this.default_modal_props,
          icon: 'error',
          title: I18n.t('error'),
          text: I18n.t(registerRes.error_code),
          okCallback: () => {
            this.setState({
              loading: false,
              isModalVisible: false
            });
          }
        }
      });
      return
    }

    await AsyncStorage.setItem(config.tokenKey, registerRes.token);
    await AsyncStorage.setItem(config.roleKey, registerRes.role);
    await AsyncStorage.setItem(config.roleValueKey, String(registerRes.value));
    await AsyncStorage.setItem(config.barsKey, JSON.stringify(registerRes.bars));

    this.setState({
      loading: true,
      is_verified: true,
      isModalVisible: true,
      fullname: registerRes?.fullname ? registerRes.fullname : '',
      modal: {
        ...this.default_modal_props,
        icon: 'success',
        title: I18n.t('success'),
        okCallback: async () => {
          this.setState({
            loading: false,
            isModalVisible: false,
          });
        }
      }
    });


  }

  validateEmail() {
    let email = this.state.email;
    let email_regex = new RegExp('^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$');
    return email_regex.test(email);
  }

  validateFullname() {
    let fullname = this.state.fullname;
    if (!fullname || !fullname.length) {
      return false;
    }
    return true;
  }

  validateOtp() {
    let otp = this.state.otp;
    let otp_regex = new RegExp('^[0-9]{3}$');
    return otp_regex.test(otp);
  }

  validateForm() {
    if (
      this.state.email === '' ||
      this.state.otp === ''
    ) {
      return false;
    }

    // validate email with regex
    if (!this.validateEmail()) {
      return false;
    }

    return true;
  }


  emailInputRender() {
    return (
      <View>
        <Text style={styles.inputHeader}>{I18n.t('email')}</Text>
        <TextInput
          ref={(input) => { this.emailInput = input; }}
          style={styles.input}
          placeholder={I18n.t('email')}
          placeholderTextColor={'gray'}
          onChangeText={(e) => {
            this.setState({ email: e, email_pristine: false });
          }}
          value={this.state.email}
          autoCapitalize='none'
          returnKeyType="send"
          onSubmitEditing={() => { this.sendOtp(); }}
          keyboardType="email-address"
          editable={!this.state.otp_sent}
        />
        {(this.validateEmail() || this.state.email_pristine) ? null : <Text style={styles.inputHelper}>{I18n.t('invalid_email')}</Text>}
      </View>
    )
  }

  otpInputRender() {
    return (
      <View>
        <Text style={styles.inputHeader}>{I18n.t('code')}</Text>
        <TextInput
          ref={(input) => { this.otpInput = input; }}
          style={styles.input}
          placeholder={I18n.t('code')}
          placeholderTextColor={'gray'}
          onChangeText={(e) => {
            this.setState({ otp: e, otp_pristine: false });
          }}
          value={this.state.otp}
          returnKeyType="done"
        />
        {(this.validateOtp() || this.state.otp_pristine) ? null : <Text style={styles.inputHelper}>{I18n.t('code_should_be_3_characters')}</Text>}
      </View>
    )
  }

  fullnameInputRender() {
    return (
      <View>
        <Text style={styles.inputHeader}>{I18n.t('full_name')}</Text>
        <TextInput
          ref={(input) => { this.fullnameInput = input }}
          style={styles.input}
          placeholder={I18n.t('full_name')}
          placeholderTextColor={'gray'}
          onChangeText={(e) => {
            this.setState({ fullname: e, fullname_pristine: false });
          }}
          value={this.state.fullname}
          autoCapitalize='none'
          returnKeyType="next"
        />
        {(this.validateFullname() || this.state.fullname_pristine) ? null : <Text style={styles.inputHelper}>{I18n.t('invalid_fullname')}</Text>}
      </View>
    )
  }


  render() {
    return (
      <KeyboardAvoidingView
        behavior={Platform.OS === "ios" ? "padding" : "height"}
        style={styles.container}
      >
        <SafeAreaView style={styles.container}>
          <View style={commonStyles.centeredView}>
          <ScrollView style={styles.scrollView} contentContainerStyle={{ flexGrow: 1, justifyContent: 'space-between' }}>
            
            {(!this.state.is_verified) ? (
              <>

              <View>
                <TouchableOpacity onPress={() => {
                  // go back, if unable to go back, go to home
                  if (this.props.navigation.canGoBack()) {
                    this.props.navigation.goBack();
                  } else {
                    this.props.navigation.reset({
                      index: 0,
                      routes: [{ name: 'Login' }]
                    });
                  }
                }}>
                  {(Platform.OS === 'web') ? (
                    <Image
                      source={require('./../assets/icons/left-chevron.svg')} style={{width: 40, height: 40}}
                    />
                  ) : (
                    <LeftChevronIcon width={40} height={40} />
                  )}
                </TouchableOpacity>
              </View>

              <View>
              <Text style={styles.title}>{I18n.t('continue_with_email')}</Text>

              {this.emailInputRender()}

              {(!this.state.otp_sent) ? (
                <TouchableOpacity
                  style={this.validateEmail() ? styles.button : styles.disabled_button}
                  disabled={!this.validateEmail() || this.state.otp_sent}
                  onPress={() => {
                    this.sendOtp();
                  }}
                >
                  <Text style={styles.buttonText}>{I18n.t('send_code')}</Text>
                </TouchableOpacity>
              ) : null}

              {(this.state.otp_sent) ? (
                <View>
                  <View style={{flexDirection: 'row', justifyContent: 'space-between', margin: 10}}>
                    <View>
                      <Text style={{color: 'black'}}>
                        {I18n.t('code_sent_to')} <Text style={{ color: config.primaryColor }}>{this.state.email}</Text>
                      </Text>
                    </View>
                    <View>
                      <Text style={{color: 'black'}}
                        onPress={() => {
                          this.setState({
                            otp_sent: false,
                            otp_timer: 0
                          });
                          if(this.otpTimer)
                            clearInterval(this.otpTimer);
                        }}
                      >{I18n.t('edit')}</Text>
                    </View>
                  </View>

                  {(this.state.otp_timer > 0) ? (
                    <Text style={{margin: 10, color: 'black'}}>
                      {I18n.t('resend_code_in')} <Text style={{ color: config.primaryColor }}>{this.state.otp_timer}</Text> {I18n.t('seconds')}
                    </Text>
                  ) : null}
                </View>
              ) : null}

              {(this.state.otp_sent && this.state.otp_timer == 0) ? (
                <TouchableOpacity
                  style={(!this.validateEmail() || this.state.otp_timer > 0) ? styles.disabled_button : styles.button}
                  disabled={!this.validateEmail() || this.state.otp_timer > 0}
                  onPress={() => {
                    this.sendOtp();
                  }}
                >
                  <Text style={styles.buttonText}>{I18n.t('resend_code')}</Text>
                </TouchableOpacity>
              ) : null}

              {(this.state.otp_sent) ? (
                <View>
                  {this.otpInputRender()}
                  <TouchableOpacity
                    style={(!this.validateEmail() || !this.validateOtp() || this.state.loading) ? styles.disabled_button : styles.button}
                    onPress={() => {
                      this.login();
                    }}
                    disabled = {(!this.validateEmail() || !this.validateOtp() || this.state.loading)}
                  >
                    <Text style={styles.buttonText}>{I18n.t('validate')}</Text>
                  </TouchableOpacity>
                </View>
              ) : null}
              </View>

              <View>
                <Text style={{textAlign: 'center', margin: 20, color: 'black'}}>
                  {I18n.t('already_have_an_account')} <Text style={{ color: config.primaryColor }} onPress={async () => {
                    this.setState({
                      loading: true,
                      isModalVisible: true,
                      modal: this.loading_modal_props
                    });
                    this.props.navigation.reset({
                      index: 0,
                      routes: [{ name: 'Login', params: { redirectTo: this.redirectTo, barId: this.barId, tableNumber: this.tableNumber } }],
                    });
                    this.setState({
                      loading: false,
                      isModalVisible: false
                    });
                  }}>{I18n.t('login')}</Text>
                </Text>
              </View>

              </>
            ) : null}

            {(this.state.is_verified) ? (
              <>
              <View></View>
              <View>
                {this.fullnameInputRender()}

                <TouchableOpacity
                  style={(!this.validateFullname() || this.state.loading) ? styles.disabled_button : styles.button}
                  onPress={async () => {
                    this.setState({
                      loading: true,
                      isModalVisible: true,
                      modal: this.loading_modal_props
                    });

                    // TODO - Save full name
                    let payload = {
                      fullname: this.state.fullname
                    }

                    try {
                      await profileService.update_profile(payload);
                    } catch (e) {
                      console.log("Error updating fullname", e.message);
                    }


                    try {
                      this.props.navigation.reset({
                        index: 0,
                        routes: [{ name: this.redirectTo ? this.redirectTo : 'Home', params: { barId: this.barId, tableNumber: this.tableNumber } }],
                      });
                      this.setState({
                        loading: false,
                        isModalVisible: false
                      });
                    } catch (e) {
                      this.setState({
                        loading: true,
                        isModalVisible: true,
                        modal: {
                          ...this.default_modal_props,
                          icon: 'error',
                          title: I18n.t('unknown_error_occurred'),
                          text: I18n.t('please_login_again'),
                          okCallback: () => {
                            this.props.navigation.reset({
                              index: 0,
                              routes: [{ name: 'Login', params: { redirectTo: this.redirectTo, barId: this.barId, tableNumber: this.tableNumber } }]
                            });
                            this.setState({
                              loading: false,
                              isModalVisible: false
                            });
                          }
                        }
                      })
                    }

                  }}
                  disabled = {(!this.validateFullname() || this.state.loading)}
                >
                  <Text style={styles.buttonText}>{I18n.t('continue')}</Text>
                </TouchableOpacity>
              </View>
              <View></View>
              </>
            ) : null}
              
              <AlertPopUpModal
                isVisible={this.state.isModalVisible}
                {...this.state.modal}
                cancelRequestCallback={() => {
                  this.setState({
                    loading: false,
                    isModalVisible: false
                  })
                }}
              ></AlertPopUpModal>

          </ScrollView>
          </View>
        </SafeAreaView>
      </KeyboardAvoidingView>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1
  },
  title: {
    padding: 15,
    margin: 20,
    fontSize: 30,
    fontWeight: 'bold',
    textAlign: 'center',
    color: config.primaryColor
  },
  inputHeader: {
    // margin: 10,
    padding: 15,
    paddingBottom: 10,
    fontSize: 15,
    color: 'black'
  },
  input: {
    // borderWidth: 0,
    // borderColor: config.primaryColor,
    borderRadius: 5,
    height: 50,
    borderColor: '#dfdfdf',
    borderWidth: 1,
    margin: 10,
    marginTop: 0,
    padding: 15,
    color: 'black'
  },
  inputHelper: {
    margin: -10,
    padding: 30,
    paddingTop: 0,
    paddingBottom: 10,
    fontSize: 12,
    color: 'red'
  },
  scrollView: {
    backgroundColor: 'white',
    marginHorizontal: 0
  },
  text: {
    fontSize: 42,
  },
  button: {
    backgroundColor: config.primaryColor,
    padding: 15,
    margin: 10,
    marginTop: 20,
    borderRadius: 5,
    alignItems: 'center',
  },
  disabled_button: {
    backgroundColor: 'gray',
    padding: 15,
    margin: 10,
    marginTop: 20,
    borderRadius: 5,
    alignItems: 'center',
  },
  buttonText: {
    color: 'white',
    fontSize: 20,
  }
});

export default RegisterWithEmail;
